import { Stack, Typography, Rating, styled, Box, darken } from '@mui/material';
import { PublicCompanyRating } from '../../api/endpoints/CompanyApi';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const CustomerTestemonialBox = styled(Box)(({ theme }) => ({
	backgroundColor: darken(theme.palette.background.paper, 0.2),
	boxShadow: theme.shadows[2],
	padding: theme.spacing(2),
	borderRadius: theme.spacing(1),
	borderBottomLeftRadius: 0,
	alignSelf: 'flex-start',
	maxWidth: '80%',
	// every other testimonial should have a different background color
	'&:nth-child(odd)': {
		backgroundColor: darken(theme.palette.background.paper, 0.3),
		alignSelf: 'flex-end',
		borderBottomRightRadius: 0,
		borderBottomLeftRadius: theme.spacing(1),
	},
}));

type CustomerTestemonialProps = {
	comment?: string;
};

function CustomerTestemonial(props: Readonly<CustomerTestemonialProps>) {
	const { comment } = props;
	if (!comment) {
		return null;
	}
	return (
		<CustomerTestemonialBox>
			<Typography variant="body2">{comment}</Typography>
		</CustomerTestemonialBox>
	);
}

type CompanyPublicReviewsProps = {
	reviews?: PublicCompanyRating;
};

function CompanyPublicReviews(props: Readonly<CompanyPublicReviewsProps>) {
	const { reviews } = props;
	if (!reviews) {
		return null;
	}

	return (
		<Stack
			spacing={2}
			alignItems="center"
			justifyContent="space-evenly"
			direction="column"
			sx={{ marginBottom: 2 }}
		>
			<Typography gutterBottom variant="h5" component="h2">
				Se hva våre kunder sier om oss
			</Typography>
			<Rating
				size="large"
				name="star-rating"
				value={reviews.avgRating}
				readOnly
				defaultValue={0}
				max={5}
				emptyIcon={<StarBorderIcon style={{ opacity: 0.7 }} fontSize="inherit" />}
				sx={{
					m: 1,
					fontSize: '2rem',
					// show num reviews after
					'&::after': {
						content: `'(${reviews.numReviews})'`,
						marginLeft: '0.5rem',
						fontSize: '1.5rem',
					},
				}}
			/>
			<Typography gutterBottom variant="body2">
				Noen omtaler fra våre kunder:
			</Typography>

			{(reviews.comments ?? []).slice(0, 5).map((comment: any, index: number) => (
				<CustomerTestemonial key={index} comment={comment} />
			))}
		</Stack>
	);
}

export default CompanyPublicReviews;
